// shared.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs'; 
import { HttpClient } from '@angular/common/http';
import { ApiService } from "./api.service";
import { HttpHeaders } from '@angular/common/http';
import { encode_base64, encode_utf8, environment } from "../../environments/environment"
declare var $: any;

export interface LabelModalFields {
  clinicAddress: string;
  clientInfo: string;
  date: string;
  warning: string;
  productInfo: string;
  doctor: string;
  details: string;
  noOfTabs: string;
  useOf: string;
  code: string;
  methodOfIssue: string;
}

interface CameraPayload {
  origin: any;
  value: any;
} 
interface SearchPersonload {
  origin: any;
  value: any;
} 

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  selectedFile: File | null = null;

  constructor( 
    private http: HttpClient,
    private api:ApiService
  ) { }
   
  private printInvoiceSubject = new Subject<void>(); 
  printInvoiceObservable = this.printInvoiceSubject.asObservable(); 
  triggerPrintInvoice() {
    console.log('shared service triggerPrintInvoice');
    this.printInvoiceSubject.next();
  }

  // private CameraInitSubject = new Subject<void>(); 
  // CameraInitObservable = this.CameraInitSubject.asObservable(); 
  // triggerCameraInit() {
  //   console.log('shared service triggerPrintInvoice');
  //   this.CameraInitSubject.next();
  // }

  private CameraInitSubject= new Subject<SearchPersonload>();
  CameraInitObservable = this.CameraInitSubject.asObservable(); 
  triggerCameraInit(origin:any,value: any) {  
        this.CameraInitSubject.next({origin,value});
  }

  private newClientSubject = new Subject<void>(); 
  newClientObservable = this.newClientSubject.asObservable(); 
  triggernewClient() {
    this.newClientSubject.next();
  }

  private SearchPersonSubject= new Subject<SearchPersonload>();
  SearchPersonObservable = this.SearchPersonSubject.asObservable(); 
  triggerSearchPerson(origin:any,value: any) {  
        this.SearchPersonSubject.next({origin,value});
  }

  private newPersonSubject = new Subject<void>(); 
  newPersonObservable = this.newPersonSubject.asObservable(); 
  triggernewPerson() {
    this.newPersonSubject.next();
  }

  private ReturnImageIDSubject= new Subject<CameraPayload>();
  ReturnImageIDObservable = this.ReturnImageIDSubject.asObservable(); 
  triggerReturnImageID(origin:any,value: any) {  
        this.ReturnImageIDSubject.next({origin,value});
  }

  //triggerGalleryPictures
  private GalleryPicturesSubject= new Subject<void>();
  GalleryPicturesObservable = this.GalleryPicturesSubject.asObservable();
  triggerGalleryPictures() {
    this.GalleryPicturesSubject.next();
  }

  private ClientFilesSubject= new Subject<void>();
  ClientFilesObservable = this.ClientFilesSubject.asObservable();
  triggerClientFiles() {
    this.ClientFilesSubject.next();
  }

  private releaseFormLoadSubject = new Subject<void>();
  releaseFormLoadObservable = this.releaseFormLoadSubject.asObservable();
  triggerReleaseFormLoad() {
    this.releaseFormLoadSubject.next();
  }
 
 
  uploadFile(client_no: number, pet_no: number): Promise<number> {
      if (!this.selectedFile) {
          return Promise.reject('No file selected.');
      }

      const formData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name); // Ensure field name is 'file'
      formData.append('client_no', client_no.toString());
      formData.append('pet_no', pet_no.toString());

      const headers = new HttpHeaders();

      return new Promise((resolve, reject) => {
        this.api.postwh(`report/UploadFile`, formData, headers).subscribe({
              next: (res: any) => {
                  console.log('Response from server:', res);
                  resolve(res?.fileId || 0);
              },
              error: (err: any) => {
                  console.error('Error uploading file:', err);
                  reject(err);
              }
          });
      });
  }

  viewPdf(ID) {
    this.api.getFile(`pet/GetFileById/${ID}`).subscribe(blob => {
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
    });
  }

  // Shared state for the Print Label modal (ngx-labels) - lets any page (blank label, xray)
  // pre-fill the context fields it already knows (clinic/client/date/warning) and open the
  // same modal for the user to fill in Product Info/Description/Doctor before printing.
  labelModalFields: LabelModalFields = { clinicAddress: '', clientInfo: '', date: '', warning: '', productInfo: '', doctor: '', details: '', noOfTabs: '', useOf: '', code: '', methodOfIssue: '' };

  openLabelModal(context: Partial<LabelModalFields> = {}) {
    this.labelModalFields = { clinicAddress: '', clientInfo: '', date: '', warning: '', productInfo: '', doctor: '', details: '', noOfTabs: '', useOf: '', code: '', methodOfIssue: '', ...context };
    $('#modalLabels').modal('show');
  }

  /**
   * Download-then-print flow for the Work page's label buttons (blanklabel/xray): opens the
   * built label PDF in a new tab so the user can print it from their browser's own print
   * dialog, which can reach a shared/network printer (unlike the DYMO Connect browser SDK,
   * which only sees DYMO printers locally attached via USB to the machine running the browser).
   * Backed by LabelPrintController/DymoPrinter.cs - separate from the Procedure page's label system.
   */
  printLabel(fields: Partial<LabelModalFields>) {
    const payload = {
      ClinicAddress: fields.clinicAddress || '',
      ClientInfo: fields.clientInfo || '',
      Doctor: fields.doctor || '',
      Date: fields.date || '',
      ProductInfo: fields.productInfo || '',
      Details: fields.details || '',
      Warning: fields.warning || ''
    };
    this.api.postFile('LabelPrint/BuildLabel', payload).subscribe(blob => {
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
    });
  }


  DownloadSaveReport(queryString: string, reportName: string, client_no: number, pet_no: number) {
    const requestBody = {
        queryString: queryString, 
        reportName: reportName,
        client_no: client_no,
        pet_no: pet_no
    }; 

    let promise = new Promise((resolve, reject) => {
        this.http.post(`${environment.apiRoot}api/report/DownloadReport`, requestBody, { 
            headers: this.api['headers'],
            params: this.api['params']
            // Remove responseType: 'blob' since we're now getting JSON
        }).subscribe((res: any) => { 
            if (res && res.success) {
                // Convert base64 to blob and download
                const byteCharacters = atob(res.fileData);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                
                // Create download link
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = res.fileName || `${reportName}.pdf`;
                document.body.appendChild(link);
                link.click();
                
                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                resolve(res.fileId); // Return the fileId from the response
            } else {
                resolve(0);
            }
        }, (error) => {
            reject(error);
        });
    });
    
    return promise;
}

 
  GetReportData(params: { [key: string]: any }): Promise<{ fileName: string; contentType: string; data: string }> {
    const queryParams = new URLSearchParams();

    // Build token (same scheme as downloadAndSaveReport)
    const reportName = params?.report_name || '';
    const fileNameForToken = params?.file_name || 'report';
    let tokenString =
      `admin` + "U*63r" + reportName + "R0d&3" + 'pdf' + "R3nd%" + '' +
      "Fr3n6" + `${fileNameForToken} ${new Date().getTime()}` + "T1*73";
    let resultToken = encode_utf8(tokenString);
    resultToken = encode_base64(resultToken);
    queryParams.append('token', resultToken);

    // Append provided params
    Object.entries(params || {}).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, String(value));
      }
    });

    const route = `email/GetReportData?${queryParams.toString()}`;

    return new Promise((resolve, reject) => {
      this.api.get<{ fileName: string; contentType: string; data: string }>(route).subscribe({
        next: (resp) => resolve(resp),
        error: (err) => reject(err)
      });
    });
  }

  print_briefhistory(pet_no: number, clinic_no: number) { 
    let $string = `admin` + "U*63r" + 'rptBrief' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Medical History ${new Date().getTime()}` + "T1*73";
    let $result = encode_utf8($string);
    $result = encode_base64($result);
 
    let $strfilter = `&PetNo=${pet_no}&ClinicNo=${clinic_no}`;
    console.log($strfilter);

    let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;
    console.log(url);

    window.open(url, '_self', 'visible=none');
  }


  


  



}